export default __webpack_public_path__ + "static/travel-to-fashion-week-without-the-invite-8b2f67270c8f3cf2a8623d2438652ff7.jpg";